/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Lock_NowInputs */

const en_how_lock_now = /** @type {(inputs: How_Lock_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`now`)
};

const pl_how_lock_now = /** @type {(inputs: How_Lock_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teraz`)
};

/**
* | output |
* | --- |
* | "now" |
*
* @param {How_Lock_NowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_lock_now = /** @type {((inputs?: How_Lock_NowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Lock_NowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_lock_now(inputs)
	return en_how_lock_now(inputs)
});